import { faCheckSquare, faSpinner } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useAvailableWallets } from '~/features/wallet/hooks/useAvailableWallets'
import { useSelectWallet } from '~/features/wallet/hooks/useSelectWallet'

export const WalletSelector = () => {
    // Opening a lootbox signs a transaction, so a wallet that cannot do that has no business
    // being on this list.
    const { available } = useAvailableWallets({ require: 'transaction' })

    // Connecting used to run from a `useEffect` on mount with `connect` in its dependency array --
    // it fired before any wallet was chosen, and re-fired whenever the callback identity changed,
    // rejecting each time into a `.catch(() => undefined)` that hid it. Selection now drives the
    // connect, once, and failures are shown.
    const { choose, pending, error, publicKey, wallet } = useSelectWallet()

    const selected = wallet?.adapter.name

    return (
        <div className='flex flex-col gap-2'>
            <div className='flex flex-row gap-4'>
                {available.map((w, i) => {
                    const isSelected = selected === w.adapter.name
                    return (
                        <div key={i}>
                            <button
                                onClick={() => choose(w.adapter.name)}
                                disabled={Boolean(pending)}
                                className='relative disabled:opacity-30 p-1'
                            >
                                <img src={w.adapter.icon} className='h-10 w-10' />
                                {pending === w.adapter.name && (
                                    <div className='absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2'>
                                        <FontAwesomeIcon icon={faSpinner} spin />
                                    </div>
                                )}
                                {isSelected && publicKey && (
                                    <FontAwesomeIcon
                                        icon={faCheckSquare}
                                        className='absolute top-0 left-0 text-green-500 bg-black'
                                    />
                                )}
                            </button>
                        </div>
                    )
                })}
            </div>
            {available.length === 0 && (
                <small className='text-white/50'>No Solana wallet detected in this browser.</small>
            )}
            {error && <small className='font-bold text-red-400'>{error}</small>}
        </div>
    )
}
